import {cdnImage, cdnUrl} from '@/util/cdnImage';
import {MUIButton, MUIContainer, MUIGrid, MUITypography} from '@/components/MUI-Components';
import Banner from '@/components/Ui-components/Banner';
import {NFT_MUSIC_META_DATA} from '@/util/metaData/nft';
import Box from '@mui/material/Box';
import dynamic from 'next/dynamic';
import PageHead from '@/components/PageHead';
const advimg = cdnImage('nft-music/short-banner.webp');

const transportAdvSx = {
    backgroundImage: `url(${cdnUrl('nft-music/short-banner-music.webp')})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    '@media (max-width:1199px)': {paddingTop: 0}
} as const;

const hireNativeTeamButtonSx = {
    '@media (max-width:394px) and (min-width:362px)': {padding: '10px 15px'},
    '@media (max-width:320px)': {padding: '10px 5px'}
} as const;

// Preserved from the page's former nftMusicMarketplace.module.scss — scoped
// to this page's own Banner and LetDiscuss calls, no component change needed.
const nftMusicBannerImageBoxSx = {
    textAlign: 'center !important',
    '& img': {width: '450px !important'},
    '@media (max-width: 1199px)': {
        width: '400px !important',
        '& img': {width: '100% !important'}
    },
    '@media (max-width: 600px)': {
        textAlign: 'center !important',
        width: '100% !important',
        '& img': {width: '100% !important'}
    }
} as const;

const nftMusicSpriellImageSx = {top: 'auto !important'} as const;
const OneStepSolution = dynamic(import('@/components/Ui-components/one-step-solution'));
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));
const LatestProcess = dynamic(() => import('@/components/Ui-components/latestProcess'));
const HelperSection = dynamic(() => import('@/components/Ui-components/helper-section'));
const CryptoWallet = dynamic(() => import('@/components/Ui-components/cryptowallets'));
const TransportService = dynamic(import('@/components/Ui-components/TransportService'));
const Questions = dynamic(import('@/components/Ui-components/questions'));
const Testimonials = dynamic(import('@/components/Ui-components/Testimonials'));
const LatestInsights = dynamic(import('@/components/Ui-components/latest-insights'));
const LetDiscuss = dynamic(import('@/components/Ui-components/Lets-discuss'));
const OurServices = dynamic(() => import('@/components/Ui-components/our-services'));

const NftMusic = (props: any) => {
    const {
        openForm,
        musicProcessData,
        nftMusicFAQData,
        nftMusicServiceData,
        nftMusicServices,
        nftMusicStepData,
        nftmusicSolution,
        nftmusicTransport
    } = props;
    return (
        <Box className="nft-music-main-parent">
            <PageHead meta={NFT_MUSIC_META_DATA} url="/music-nft-marketplace" />

            <Banner
                priority={true}
                handleClickOpen={openForm}
                heading="NFT Music Marketplace Development"
                subheading="Discover the potential of the music industry with our comprehensive NFT Music Marketplace Development services. Our platform takes a modern approach to purchasing, owning, and trading music NFTs, making it easier for artists to monetise their work and fans to purchase one-of-a-kind musical compositions. Join us in defining the digital future of the music industry."
                button="Launch Your NFT Music Platform Today "
                image={cdnImage('nft-music/Nft Music Marketplace Development.webp')}
                bannerClass="nft-music-banner"
                bannerImageBoxSx={nftMusicBannerImageBoxSx}
                // bannerBackground="nft-music-banner-background"
                alt="Nft Music Marketplace Development"
            />

            <Box className="one-step top-space bottom-spacing">
                <MUIContainer>
                    <OneStepSolution
                        OneStepData={nftMusicStepData}
                        sectionhead="Advancing the Music Industry with Professional NFT Marketplace Development Services"
                        subhead="As the music sector adapts to digital innovation, NFT Music Marketplace Development emerges as a key driver of change. This initiative paves the way for artists to monetize their creations through NFTs, offering a platform for the sale, purchase, and exchange of music-related digital assets, thereby fostering a new era of musical commerce."
                        className="contact-solution"
                    />
                </MUIContainer>
            </Box>

            <Box className="hire-native-team seamless-efficient-wrapper">
                <MUIContainer>
                    <MUIGrid item xs={12}>
                        <MUIGrid container spacing={3} justifyContent="space-around">
                            <MUIGrid item xs={12} sm={12} md={6} lg={7}>
                                <Box className="spectrum-header-wrapper solution-header-wrapper solutions">
                                    <MUITypography className="spectrum-heading top-spacing">
                                        Transform Music Ownership: Empower Creators, Captivate Audiences, and Forge the Future Together
                                    </MUITypography>
                                    <Box className="top-spacing ">
                                        <MUIButton
                                            className="nft-button"
                                            variant="contained"
                                            label="Schedule a Consultation Today"
                                            onClick={openForm}
                                            sx={hireNativeTeamButtonSx}
                                        />
                                    </Box>
                                </Box>
                            </MUIGrid>
                            <MUIGrid item xs={12} sm={12} md={6} lg={5} className="native-img top-spacing" textAlign="center">
                                <DisplayImage
                                    src={advimg}
                                    alt="Blockchain devlopment company "
                                    className="exchange-adv-img"
                                    width={290}
                                    height={280}
                                />
                            </MUIGrid>
                        </MUIGrid>
                    </MUIGrid>
                </MUIContainer>
            </Box>
            <Box>
                <MUIContainer>
                    <LatestProcess
                        heading="From Soundwaves to NFTs: The Process of Crafting Digital Artistry in Music"
                        subheading="Learn about the method of converting music into digital assets through NFT technology. This process allows artists to permanently encode their soundwaves as NFTs, opening up novel opportunities for music ownership, distribution, and valuation in the digital marketplace."
                        processData={musicProcessData}
                    />
                    <MUITypography className="one-step-footer">
                        Navigate Your Way to Musical Innovation: Utilize the Best NFT Platform for Music to Empower Artists and Simplify
                        Access to Music NFTs and Tokens
                    </MUITypography>

                    <MUIGrid container justifyContent="center">
                        <Box className="bottom-space">
                            <MUIButton
                                label="Launch Your Platform Today"
                                variant="contained"
                                className="helper-card-button"
                                aria-label="Book Consultation"
                                onClick={openForm}
                            />
                        </Box>
                    </MUIGrid>
                </MUIContainer>
            </Box>
            <MUIGrid item xs={12} className="helper-section top-spacing">
                <Box className="helper_section_parent bottom-spacing">
                    <MUIContainer>
                        <Box className="spectrum-header-wrapper solutions top-space">
                            <MUITypography className="spectrum-heading color-black " component="h2">
                                Choosing Debut&apos;s White Label Solution: The Premier NFT Music Platform for Marketplace Success
                            </MUITypography>
                            <Box className="divder-wrapper">
                                <hr className="divider-line" />
                            </Box>
                            <Box pb={6}>
                                <MUITypography className="spectrum-sub-heading color-black " component="body1">
                                    Opt for Debut&apos;s White Label Solution, a leading NFT music platform tailored for marketplace
                                    excellence. Our comprehensive NFT marketplace development services cater to artists and companies
                                    looking to sell music as NFTs, offering an unparalleled music NFT marketplace for creators and
                                    collectors alike.
                                </MUITypography>
                            </Box>
                        </Box>
                        <MUIGrid container spacing={2}>
                            <HelperSection data={nftmusicSolution} className="home-helper-card" />
                        </MUIGrid>
                    </MUIContainer>
                </Box>
            </MUIGrid>
            <MUIGrid item xs={12} sx={transportAdvSx}>
                <MUIContainer>
                    <MUIGrid container>
                        <MUIGrid item xs={12} sm={12} md={7}>
                            <Box className="">
                                <MUITypography className="defi-adv-heading top-spacing">
                                    Advanced NFT Marketplace Development, Custom Solutions, and Professional Support for Music Tokens
                                </MUITypography>

                                <Box className="top-spacing bottom-spacing">
                                    <MUIButton
                                        className="nft-button"
                                        variant="contained"
                                        label="Uncover NFT Music Success Today!"
                                        onClick={openForm}
                                    />
                                </Box>
                            </Box>
                        </MUIGrid>
                    </MUIGrid>
                </MUIContainer>
            </MUIGrid>
            <Box>
                <MUIContainer>
                    <CryptoWallet
                        data={nftmusicTransport}
                        heading="Platform Owners Centric Features of Our White Label NFT Music Marketplace Solutions"
                        subheading="Our White Label NFT Music Marketplace Solutions are designed with platform owners in mind, featuring robust NFT marketplace development services and technologies. Benefit from a comprehensive music NFT platform that simplifies selling, buying, and creating music NFTs, enhancing your presence in the NFT music market."
                        className="transport-logistics-industries"
                    />
                </MUIContainer>
            </Box>
            <Box className="top-space bottom-spacing transport-component-wrapper margin">
                <MUIContainer>
                    <TransportService
                        heading="Features of Our White Label NFT Music Marketplace Solutions For Musicians"
                        subheading=""
                        service={nftMusicServiceData}
                    />
                </MUIContainer>
            </Box>
            <Box className="top-space">
                <OurServices
                    ourServices={nftMusicServices}
                    heading="Features Tailored for Buyers in Our White Label NFT Music Marketplace Solutions"
                    className="home-page-services"
                />
            </Box>
            <MUIGrid item xs={12} className="bottom-margin">
                <LetDiscuss
                    heading="Ready to Revolutionize Your Music Collection with NFTs?"
                    subheading="Dive into our NFT music marketplace and transform how you engage with music. Sell, buy, and create music NFTs on a platform designed for artists and buyers seeking innovation in the digital music landscape."
                    btnLabel="Get Started Today!"
                    openForm={openForm}
                    imageSx={nftMusicSpriellImageSx}
                />
            </MUIGrid>
            <MUIGrid item xs={12} className="question-parent margin top-space mobile-top-padding">
                <MUIContainer>
                    <Questions accordianData={nftMusicFAQData} />
                </MUIContainer>
            </MUIGrid>

            <MUIGrid item xs={12}>
                <Box className="top-space mobile-top-padding bg-blue-background">
                    <Testimonials heading="Our Clients Describe Us Best" />
                </Box>
            </MUIGrid>

            <MUIGrid item xs={12} className="latest-insights top-space mobile-top-padding">
                <LatestInsights id="23" />
            </MUIGrid>
        </Box>
    );
};
export default NftMusic;
NftMusic.Layout = 'Main';

export const getStaticProps = async () => {
    const {
        musicProcessData,
        nftMusicFAQData,
        nftMusicServiceData,
        nftMusicServices,
        nftMusicStepData,
        nftmusicSolution,
        nftmusicTransport
    } = await import('@/util/contents/nft-music');
    return {
        props: {
            musicProcessData,
            nftMusicFAQData,
            nftMusicServiceData,
            nftMusicServices,
            nftMusicStepData,
            nftmusicSolution,
            nftmusicTransport
        }
    };
};
